import React from 'react';
import { Link } from 'react-router-dom';
import { useFooterContent } from '../../../hooks/useFooterContent';
import './Footer.css';

const Footer = () => {
  const { content, isLoading } = useFooterContent();

  if (isLoading || !content) {
    return null;
  }

  const { logo, logomark, about, disclaimer, copyright, socials, columns } = content;

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__top">
          <div className="footer__brand">
            <Link to="/" className="footer__logo" aria-label="VBS Invest home">
              {logo ? (
                <img src={logo.url} alt={logo.alt} width="108" height="32" />
              ) : null}
            </Link>

            {about ? <p className="footer__about">{about}</p> : null}

            {socials.length > 0 ? (
              <ul className="footer__socials">
                {socials.map(({ name, icon, href }) => (
                  <li key={name}>
                    <a
                      className="footer__social"
                      href={href}
                      target="_blank"
                      rel="noreferrer"
                      aria-label={name}
                    >
                      <img src={icon} alt="" aria-hidden="true" width="24" height="24" />
                    </a>
                  </li>
                ))}
              </ul>
            ) : null}
          </div>

          {columns.map(({ id, title, links }) => (
            <nav className="footer__column" key={id} aria-label={title}>
              <p className="footer__column-title">{title}</p>
              <ul className="footer__links">
                {links.map(({ label, to }) => (
                  <li key={label}>
                    <Link to={to} className="footer__link">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="footer__divider" />

        <div className="footer__bottom">
          {disclaimer ? <p className="footer__disclaimer">{disclaimer}</p> : null}

          <div className="footer__bottom-row">
            <p className="footer__copyright">
              © {new Date().getFullYear()} {copyright}
            </p>
            {logomark ? (
              <a
                className="footer__mark-link"
                href="https://vuca.li/"
                target="_blank"
                rel="noreferrer"
                aria-label="Visit Vuca"
              >
                <img
                  className="footer__mark"
                  src={logomark.url}
                  alt=""
                  aria-hidden="true"
                  width="26"
                  height="16"
                />
              </a>
            ) : null}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
